import MUITypography from '@mui/material/Typography'

export const Typography = MUITypography
